import { Card } from "@/components/ui/card";
import { useAppDetails } from "@/contexts/AppDetailsContext";
import { Button } from "react-day-picker";

export default function CustomMainPage() {
  const { details } = useAppDetails();
  const openApp = () => {
    window.location.href = "myapp://open"; // your deep link
  };

  return (
    <div className="min-h-screen flex items-center justify-center  px-6">
      <Card className="max-w-md p-8 rounded-3xl text-center space-y-5">
        <img
          src={details?.brokerLogo}
          className="md:max-h-[30px] xs:max-h-[25px] max-h-[25px] sm:max-w-[300px]"
          alt=""
        />
        <h2 className="text-xl font-semibold ">Login Required</h2>
        <p className=" text-muted-foreground">
          Login to this app from your broker portal
        </p>

        <p className="text-xs text-gray-500">
          Need help? Contact {details?.supportEmail}
        </p>
      </Card>
    </div>
  );
}
